import { Modal, Button } from "react-bootstrap";
import Styles from "./DeliveryPersonModal.module.css";
import { getRiderDetailsService } from "../Services/ApiServices";
import { useEffect, useState } from "react";
import Loader from "../SharedComponents/Loader/Loader";
import toast from "react-hot-toast";
import RiderHelmet from "../Assets/person_color.png";
import Phone from "../Assets/call_color.png";

export default function DeliveryPersonModal({ show, onHide, billId }) {
  const [isLoading, setisLoading] = useState(true);
  const [errorText, seterrorText] = useState(null);

  const [deliveryPersonData, setdeliveryPersonData] = useState(null);

  useEffect(() => {
    getDeliveryPersonDetailsApiCall();
  }, []);

  const getDeliveryPersonDetailsApiCall = () => {
    setisLoading(true);
    const formData = new FormData();
    formData.append("customer_bill_id", billId);
    getRiderDetailsService(formData)
      .then((res) => {
        if (res.data.status === 1) {
          setdeliveryPersonData(res.data.data);
        } else {
          seterrorText(res.data.message);
        }
      })
      .catch((err) => {
        let errMsg = err?.response?.data?.detail?.[0]?.msg
          ? err?.response?.data?.detail?.[0]?.msg
          : "Rider details not found...";
        toast.error(errMsg, { type: "error" });
        seterrorText(errMsg);
      })
      .finally(() => {
        setisLoading(false);
      });
  };

  return (
    <>
      {isLoading && <Loader isLoader={isLoading} />}
      <Modal
        show={show}
        onHide={onHide}
        centered
        dialogClassName={Styles.smallModal}
      >
        <Modal.Header closeButton>
          <Modal.Title className={Styles.title}>
            Delivery Person Details
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Name & Mobile */}
          {!isLoading &&
            (deliveryPersonData ? (
              <>
                <div className={Styles.centerBlock}>
                  {deliveryPersonData.rider_name && (
                    <div className={Styles.infoRow}>
                      <img
                        src={RiderHelmet}
                        alt="rider"
                        className={Styles.infoIcon}
                      />
                      <p className={Styles.name}>
                        {deliveryPersonData.rider_name ?? ""}
                      </p>
                    </div>
                  )}

                  {deliveryPersonData.rider_phone && (
                    <div className={Styles.infoRow}>
                      <img
                        src={Phone}
                        alt="phone"
                        className={Styles.infoIcon}
                      />
                      <p className={Styles.mobile}>
                        {deliveryPersonData.rider_phone ?? ""}
                      </p>
                    </div>
                  )}
                </div>

                {/* OTP Section */}
                <div className={Styles.otpSection}>
                  <div className={Styles.otpBox}>
                    <span className={Styles.otpLabel}>Pickup OTP</span>
                    <span className={Styles.otpValue}>
                      {deliveryPersonData?.pick_up_otp
                        ? deliveryPersonData?.pick_up_otp
                        : "N/A"}
                    </span>
                  </div>

                  <div className={Styles.otpBox}>
                    <span className={Styles.otpLabel}>
                      Return to Origin OTP
                    </span>
                    <span className={Styles.otpValue}>
                      {deliveryPersonData.rto_otp
                        ? deliveryPersonData.rto_otp
                        : "N/A"}
                    </span>
                  </div>
                </div>
              </>
            ) : (
              errorText && (
                <div className={Styles.errorContainer}>
                  <div className={Styles.errorIcon}>⚠</div>
                  <p className={Styles.errorMessage}>{errorText}</p>
                </div>
              )
            ))}
        </Modal.Body>

        <Modal.Footer className={Styles.footer}>
          <Button variant="secondary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
